// Piezas compartidas del módulo Comedores.

const pesos = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 })
export const plata = (n) => (n == null || Number.isNaN(Number(n)) ? '—' : pesos.format(Number(n)))
export const entero = (n) => new Intl.NumberFormat('es-AR').format(Number(n) || 0)

// Las planillas traen los nombres entre comillas y con punto final ("“Semillas de Amor”",
// "Urquiza."). Para mostrar se sacan; el servidor ya los guarda limpios al editar.
export const nombreSede = (t) => String(t || '').replace(/^[\s"'“”«»]+|[\s"'“”«».]+$/g, '')

export const fechaCorta = (iso) => {
  if (!iso) return '—'
  const [a, m, d] = String(iso).slice(0, 10).split('-')
  return d && m && a ? `${d}/${m}/${a}` : iso
}

// Listas tomadas de las planillas operativas de los comedores.
export const TURNOS = ['Mañana', 'Tarde', 'Jornada Completa']
export const PARENTESCOS = ['Madre', 'Padre', 'Tutor/a Legal', 'Abuelo/a', 'Tío/a', 'Otro familiar']
export const RUBROS = [
  'Secos / Almacén', 'Carnes / Frescos', 'Pollo / Granja', 'Verduras / Frescos',
  'Lácteos / Merienda', 'Almacén / Legumbres', 'Energía / Gas', 'Equipamiento', 'Limpieza / Higiene', 'Otro',
]
export const UNIDADES = ['Bolsas', 'Kilogramos', 'Unidades', 'Cajas', 'Litros', 'Paquetes']
export const CATEGORIAS_GASTO = [
  'Servicios Básicos', 'Combustible / Gas', 'Personal / Sueldos',
  'Equipamiento Mobiliario', 'Mantenimiento / Limpieza', 'Otro',
]

export const COMIDAS = [
  { key: 'desayuno', corto: 'D', label: 'Desayuno' },
  { key: 'almuerzo', corto: 'A', label: 'Almuerzo' },
  { key: 'merienda', corto: 'M', label: 'Merienda' },
]
